export class Claim {
    public type: string;
    public value: string;
    public name: string;
    public enabled: boolean;
}
